export default __webpack_public_path__ + "static/media/scanner_face.2c336050.png";